export default __webpack_public_path__ + "static/media/Warglory Gauntlets.60c69e08.jpg";